import React, { useEffect, useState } from 'react';
import { invoiceApi, creditNoteApi, formatApiError } from '../services/api';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { Button } from './ui/button';

export default function InvoicePreview({ invoice, onClose }) {
  const [url, setUrl] = useState(null);
  const [error, setError] = useState('');
  const [attempt, setAttempt] = useState(0);
  const isCredit = invoice.invoice_type === 'gutschrift';
  const label = isCredit ? 'Gutschrift' : 'Rechnung';
  const filename = `${isCredit ? 'gutschrift' : 'rechnung'}_${invoice.invoice_number || invoice.id}.pdf`.replace(/[\\/:*?"<>|]/g, '_');

  useEffect(() => {
    let active = true;
    let objectUrl;
    setUrl(null); setError('');
    (isCredit ? creditNoteApi : invoiceApi).getPdf(invoice.id).then(response => {
      if (!active) return;
      objectUrl = URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
      setUrl(objectUrl);
    }).catch(async e => {
      let message = formatApiError(e);
      // Axios returns error responses as blobs too when requesting a PDF.
      if (e.response?.data instanceof Blob) {
        try { message = formatApiError({ response: { data: JSON.parse(await e.response.data.text()) } }); }
        catch (_) { /* Keep the readable fallback for non-JSON errors. */ }
      }
      if (active) setError(message);
    });
    return () => { active = false; if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [invoice.id, isCredit, attempt]);

  return <Dialog open onOpenChange={open => { if (!open) onClose(); }}>
    <DialogContent className="max-w-5xl max-h-[95vh] overflow-y-auto" aria-describedby="invoice-preview-description">
      <DialogHeader><DialogTitle>{label} {invoice.invoice_number || ''} · Vorschau</DialogTitle></DialogHeader>
      <p id="invoice-preview-description" className="text-sm text-[#525866]">PDF der gespeicherten {label} ansehen und bei Bedarf herunterladen.</p>
      {error ? <div role="alert" className="space-y-3"><p className="text-red-700">{error}</p><Button variant="outline" onClick={() => setAttempt(value => value + 1)}>Erneut versuchen</Button></div>
        : !url ? <p role="status">{label} wird geladen …</p>
        : <><object data={url} type="application/pdf" aria-label={`${label} Vorschau`} className="w-full h-[65vh]"><p>Die PDF-Vorschau wird hier nicht unterstützt. Bitte die Datei in einem neuen Tab öffnen oder herunterladen.</p></object><a href={url} target="_blank" rel="noreferrer" className="text-sm underline">Vorschau in neuem Tab öffnen</a></>}
      <div className="flex flex-wrap justify-end gap-2"><Button variant="outline" onClick={onClose}>Schließen</Button>{url ? <Button asChild><a href={url} download={filename}>{label} herunterladen</a></Button> : <Button disabled>{label} herunterladen</Button>}</div>
    </DialogContent>
  </Dialog>;
}
